import { Tooltip as T } from 'radix-ui';
import { type ReactNode } from 'react';

export const ProvedorDicas = T.Provider;

interface DicaProps {
  texto: ReactNode;
  children: ReactNode;
  /** Controle de fora (ex.: abrir com toque); sem ele, abre por hover e foco. */
  aberta?: boolean | undefined;
  aoMudar?: ((aberta: boolean) => void) | undefined;
}

/** Dica curta ao passar o mouse ou focar. Nunca é o único lugar de uma informação essencial. */
export function Dica({ texto, children, aberta, aoMudar }: DicaProps) {
  const controle = {
    ...(aberta === undefined ? {} : { open: aberta }),
    ...(aoMudar ? { onOpenChange: aoMudar } : {}),
  };
  return (
    <T.Root delayDuration={300} {...controle}>
      <T.Trigger asChild>{children}</T.Trigger>
      <T.Portal>
        <T.Content
          sideOffset={6}
          className="z-50 max-w-64 rounded-controle bg-texto px-2.5 py-1.5 text-xs text-texto-inverso shadow-media animate-surgir"
        >
          {texto}
        </T.Content>
      </T.Portal>
    </T.Root>
  );
}
